import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { MasterBrand } from './master-brands.entity';
import { MasterBrandAdapter } from './dto/master-brands.adapter';
import { MasterBrandDTO } from './dto/master-brands.dto';
import { MasterBrandRequest } from './dto/master-brands.request';
import { AllMasterBrandsResponseModel, BrandIDReq, BrandsDto, MasterBrandResponse, MasterBrandResponseModel, MasterBrandsDropDownDto, MasterBrandsResponseModel, MasterDropDownResponseModel } from '@gtpl/shared-models/masters';
import axios from 'axios';
import { connection } from '@gtpl/shared-services/masters';
import { truncate } from 'fs';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import appSettings from 'apps/services/config';
import { Brands } from '../end-customer/brands.entity';



@Injectable()
export class MasterBrandsService {
    constructor(
      private logService:LogsService,
        @InjectRepository(MasterBrand) private masterBrandRepository: Repository<MasterBrand>,
        private masterBrandAdapter: MasterBrandAdapter,
        @InjectRepository(Brands) private brandsRepo : Repository<Brands>,
        
    ) { }

    async getMasterBrandWithoutRelations(brandName: string): Promise<MasterBrand> {
        //  console.log(employeeId);
        const response = await this.masterBrandRepository.findOne({
            where: { masterBrandName: Raw(alias => `brand_name = "${brandName}"`) },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createMasterBrand(masterBrandDto: MasterBrandDTO, isUpdate: boolean = false, @Req() request?: Request): Promise<MasterBrandResponseModel> {
        try {
            console.log('*******************',masterBrandDto)
          let previousValue
            if (!masterBrandDto.masterBrandId) {
                const brandEntity = await this.getMasterBrandWithoutRelations(masterBrandDto.masterBrandName);
                if (brandEntity) {
                    throw new MasterBrandResponseModel(false,11104, 'brand already exists');
                }
            }
            else {
                const previous = await this.masterBrandRepository.findOne({where:{masterBrandId:masterBrandDto.masterBrandId}})
                previousValue = previous.masterBrandName+" , "+previous.displayBrandName;
                const brandEntity = await this.getMasterBrandWithoutRelations(masterBrandDto.masterBrandName);
                if (brandEntity) {
                    if (brandEntity.masterBrandId != masterBrandDto.masterBrandId) {
                        throw new MasterBrandResponseModel(false,11104, 'Brand already exists');
                    }
                }
            }
            console.log('---------dto',masterBrandDto)
            const brandEntity: MasterBrand = this.masterBrandAdapter.convertDtoToEntity(masterBrandDto,isUpdate);
            // console.log('testEntity',brandEntity)
            const savedBrandEntity: MasterBrand = await this.masterBrandRepository.save(brandEntity);
            // console.log('save', savedBrandEntity)
            const savedBrandDto: MasterBrandDTO = this.masterBrandAdapter.convertEntityToDto(savedBrandEntity);

            if (savedBrandEntity) {
            const certificatePresent = savedBrandEntity.masterBrandName+" , "+savedBrandEntity.displayBrandName;
                const response = new MasterBrandResponseModel(true, isUpdate ? 11100 : 11101, isUpdate ? 'Brand Updated Successfully' : 'Brand Created Successfully', savedBrandDto);
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Brand Updated Successfully': 'Brand Created Successfully'
            const userName = isUpdate? savedBrandEntity.updatedUser :savedBrandEntity.createdUser;
                const newLogDto = new LogsDto(1,name, 'MasterBrand', savedBrandEntity.masterBrandId, true, displayValue,userName,previousValue,certificatePresent)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new MasterBrandResponseModel(false,11106, 'Brand saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }
    async getAllMasterBrands(req?:UserRequestDto): Promise<AllMasterBrandsResponseModel> {
        try {
            const brandDto: MasterBrandDTO[] = [];
            // retrieves all plants
            const brandEntities: MasterBrand[] = await this.masterBrandRepository.find({
                order: { masterBrandName: "DESC" },
            });
            if (brandEntities.length > 0) {
                brandEntities.forEach(brandEntity => {
                    const convertedbrandDto: MasterBrandDTO = this.masterBrandAdapter.convertEntityToDto(brandEntity);
                    brandDto.push(convertedbrandDto);
                });
                const response = new AllMasterBrandsResponseModel(true, 11208, "Brand retrieved successfully", brandDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'MasterBrand', 0, true, 'Brand retrieved successfully',req.createdUser,'',"")
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
            
                return response;
            } else {
                throw new AllMasterBrandsResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getMasterBrandForId(brandId: number): Promise<MasterBrandResponse> {
        const responseData = await this.masterBrandRepository.findOne({
            where: {masterBrandId: brandId},
            });
            if (responseData) {
                const response = new BrandsDto(responseData.masterBrandId,responseData.masterBrandName,responseData.filePath,responseData.fileName,"http://142.93.219.119/erpx/dist/apps/services/masters/"+responseData.filePath,responseData.isActive,responseData.createdAt,responseData.createdUser,responseData.updatedAt,responseData.updatedUser,responseData.versionFlag,responseData.isPouchVariantConsider,responseData.isPouchBapNoConsider,responseData.isPouchGradeConsider,responseData.isCartonVariantConsider,responseData.isCartonBapNoConsider,responseData.isCartonGradeConsider,responseData.displayBrandName);
                return new MasterBrandResponse(true,1001,"Brand retrived Successfully. ", response);
            } else {
                return new MasterBrandResponse(false,1010,"No data found. ");
            }
    }
    async activateOrDeactivateMasterBrand(brandReq: MasterBrandRequest): Promise<MasterBrandResponseModel> {
        try {
            const brandExists = await this.getMasterBrandById(brandReq.masterBrandId);
            if (brandExists) {
                if (brandReq.versionFlag !== brandExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current brand information.Refresh and try again');
                } else {

                    const brandStatus = await this.masterBrandRepository.update(
                        { masterBrandId: brandReq.masterBrandId },
                        { isActive: brandReq.isActive, updatedUser: brandReq.updatedUser });
                    const brandsInfo = await this.brandsRepo.update({masterBrandId :  brandReq.masterBrandId} ,{isActive :brandReq.isActive ,updatedUser: brandReq.updatedUser})
                    if (brandExists.isActive) {
                        if (brandStatus.affected) {
                            const brandResponse: MasterBrandResponseModel = new MasterBrandResponseModel(true, 10115, 'Brand is de-activated successfully');
                            return brandResponse;
                        } else {
                            throw new MasterBrandResponseModel(false,10111, 'Brand is already deactivated');
                        }
                    } else {
                        if (brandStatus.affected) {
                            const brandResponse: MasterBrandResponseModel = new MasterBrandResponseModel(true, 10114, 'Brand is activated successfully');
                            return brandResponse;
                        } else {
                            throw new MasterBrandResponseModel(false,10112, 'Brand is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new MasterBrandResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getMasterBrandById(brandId: number): Promise<MasterBrand> {
        //  console.log(employeeId);
        const Response = await this.masterBrandRepository.findOne({
            where: { masterBrandId: brandId },
        });
        // console.log(employeeResponse);
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getAllMasterBrandsDropDown(): Promise<MasterDropDownResponseModel> {
        try {
            const brandDto: MasterBrandsDropDownDto[] = [];
            // retrieves all plants
            const brandEntities: MasterBrand[] = await this.masterBrandRepository.find({
                order: { masterBrandName: "ASC" }, where: { isActive: true }
            });
            if (brandEntities.length > 0) {
                brandEntities.forEach(brandEntity => {
                    const convertedbrandDto = new MasterBrandsDropDownDto(brandEntity.masterBrandId, brandEntity.masterBrandName);
                    brandDto.push(convertedbrandDto);
                });
                const response = new MasterDropDownResponseModel(true, 11208, "Brands retrieved successfully", brandDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getBrandInfoById(brandId: number):Promise<CommonResponse> {
        try {
            const Response = await this.masterBrandRepository.findOne({
                where: { masterBrandId: brandId },
            });

            if (Response) {
                return new CommonResponse(true, 11111, 'Brand Info Retrieved Successfully', Response);
            } else {
                return new CommonResponse(false, 99999, 'Not Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getAllActiveMasterBrands(): Promise<MasterBrandsResponseModel> {
        const response:BrandsDto[] = [];
        const responseData = await this.masterBrandRepository.find({
            where: {isActive: true},
            });
            if (responseData) {
                responseData.forEach((item) => {
                    const data = new BrandsDto(item.masterBrandId,item.masterBrandName,item.filePath,item.fileName,"http://142.93.219.119/erpx/dist/apps/services/masters/"+item.filePath,item.isActive,item.createdAt,item.createdUser,item.updatedAt,item.updatedUser,item.versionFlag,item.isPouchVariantConsider,item.isPouchBapNoConsider,item.isPouchGradeConsider,item.isCartonVariantConsider,item.isCartonBapNoConsider,item.isCartonGradeConsider,item.displayBrandName);
                    response.push(data);
                })
                
                return new MasterBrandsResponseModel(true,1001,"Brand retrived Successfully. ", response);
            } else {
                return new MasterBrandsResponseModel(false,1010,"No data found. ");
            }
    }

    async getDisplayBrandsById(req:BrandIDReq): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT master_brand_id as masterBrandId , display_brand_name as displayBrandName FROM `+appSettings.masters_db + `.master_brands WHERE master_brand_id =`+ req.brandId;
            const data = await manager.query(query)
            // let response;
            // const brands = await this.masterBrandRepository.findOne({select: ["masterBrandId", "displayBrandName"],where: { masterBrandId: req.brandId } });
            // console.log('------',brands)
            // if (brands != undefined) {
            //     response = new CommonResponse(true, 11101, 'Brands retrived Successfully', brands);
            // }
            // else {
            //     response = new CommonResponse(false, 1101, 'No data found',);
            // }
            console.log('**********',data)
            if(data.length > 0){
               return new CommonResponse(true, 11101, 'Display Brands retrived Successfully', data[0]);
            }else{
               return new CommonResponse(false, 1101, 'No data found',);
            }
        } catch (err) {
            return err;
        }
    }
   

}
